<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2780_215385)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.585786 5.08579C0 5.67157 0 6.61438 0 8.5V13.5C0 15.3856 0 16.3284 0.585786 16.9142C1.17157 17.5 2.11438 17.5 4 17.5H18C19.8856 17.5 20.8284 17.5 21.4142 16.9142C22 16.3284 22 15.3856 22 13.5V8.5C22 6.61438 22 5.67157 21.4142 5.08579C20.8284 4.5 19.8856 4.5 18 4.5H4C2.11438 4.5 1.17157 4.5 0.585786 5.08579ZM12 6.85242C11.4477 6.85242 11 7.30013 11 7.85242V14.1476C11 14.6999 11.4477 15.1476 12 15.1476H18.2952C18.8475 15.1476 19.2952 14.6999 19.2952 14.1476V7.85242C19.2952 7.30013 18.8475 6.85242 18.2952 6.85242H12Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2780_215385">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
